import { useQuery } from '@tanstack/react-query';

import { PartnersService } from '@/openapi';

export const partnersKeys = {
  all: ['partners'] as const,
  list: () => [...partnersKeys.all] as const,
} as const;

export const usePartnersQuery = () =>
  useQuery({
    queryKey: partnersKeys.list(),
    queryFn: () => PartnersService.partnersServiceGetPartners(),
  });
